export default {
    CREATE_ENTREPRISE(state, entreprise) {
        state.entreprise = entreprise;
    },

    CREATE_PROJECT(state, project) {
        state.project = project;
    },

    ADD_OFFER(state, offer) {
        if (state.offers.length === 0) {
            state.offers.push(offer);
        } else {
            let index = state.offers.findIndex(item => item.id == offer.id);
            if (index === -1) {
                state.offers.push(offer);
            } else {
                state.offers[index] = offer;
            }
        }
    },

    REMOVE_OFFER(state, id) {
        let index = state.offers.findIndex(offer => offer.id == id);
        if (index !== -1) state.offers.splice(index, 1);
    },

    CREATE_CLIENT(state, client) {
        if (state.clients.length === 0) {
            state.clients.push(client);
        } else {
            let index = state.clients.findIndex(item => item.id == client.id);
            if (index === -1) {
                state.clients.push(client);
            } else {
                state.clients[index] = client;
            }
        }
    },

    REMOVE_CLIENT(state, id) {
        let index = state.clients.findIndex(client => client.id == id);
        if (index !== -1) state.clients.splice(index, 1);
    },

    PUT_ENTREPRISES(state, entreprises) {
        state.entreprise = entreprises;
    },

    PUT_PROJECTS(state, project) {
        state.project = project;
    },

    PUT_OFFERS(state, offers) {
        state.offers = offers;
    },

    PUT_CLIENTS(state, clients) {
        state.clients = clients;
    }
};
